// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___sSWh","rootNoMargin":"styles_rootNoMargin__2B-Mo"};